import { useDispatch, useSelector } from 'react-redux';
import { useScrollWithShadow } from '@components/Boss/useScrollWithShadow';
import { getLabelFallback, roundNumber } from '@utils/utils';
import SlimArrow from '@images/svg-icons/slim-arrow.svg';
import { useState, useEffect } from 'react';
import { MapContainer } from '@components/Boss/MapContainer';
import * as actions from '@redux-actions/';

const SearchResult = props => {
  const dispatch = useDispatch();
  const physicalStores = useSelector((state) => state.cart.physicalStores);
  const selectedStore = useSelector((state) => state.cart.selectedStore);
  const isMobile = useSelector((state) => state.cart.isMobile);
  const mapLink = useSelector((state) => state.cart.mapLink);
  const { shadow, onScrollHandler, background } = useScrollWithShadow();
  const [showStoreHours, setShowStoreHours] = useState(true);
  const [storesList, setStoresList] = useState([]);
  const [storesListMobile, setStoresListMobile] = useState([]);

  useEffect(() => {
    setShowStoreHours(isMobile);
    if (isMobile) {      
      dispatch(actions.setSelectedStore(null));
    }
  }, [isMobile]);

  useEffect(() => {
    if(!!physicalStores) {
      setStoresList(createPhysicalStoreListDesktop());
      setStoresListMobile(createPhysicalStoreListMobile());
    }
  }, [physicalStores]);

  useEffect(() => {
      setStoresList(createPhysicalStoreListDesktop());
      setStoresListMobile(createPhysicalStoreListMobile());
  }, [selectedStore]);

  useEffect(() => {
    setStoresListMobile(createPhysicalStoreListMobile());
  }, [showStoreHours]);

  const createPhysicalStoreListDesktop = () => {
    return physicalStores.map((store, index) => (
      <div key={index}>
        <div className="container-fluid-boss" onClick={() => clickedStore(store)}>
          <div className="row store-record">
            <div className="store-radio-input">
              <input
                id={`selected_store_${index}`}
                className="radio-input"
                name="selected-store"
                type="radio"
                checked={!!selectedStore && selectedStore.uniqueID === store.uniqueID}
                value={store}
                onChange={() => dispatch(actions.setSelectedStore(store))}
                data_analytics-available-call='0'
              ></input>
              <label htmlFor={`selected_store_${index}`} 
                className={
                  !!selectedStore && selectedStore.uniqueID === store.uniqueID ? 'checked' : ''
                }
              ></label>
            </div>
            <label className="store-name">{store.Description[0].displayStoreName.toLowerCase().replace('lenscrafters', 'LensCrafters')}</label>
            <div className="store-miles align-right">
              {roundNumber(store.distance) + getLabelFallback('CURRENCY_DISTANCE_LABEL')}
            </div>
          </div>
        </div>
      </div>
    ));
  }

  const createPhysicalStoreListMobile = () => {
    return physicalStores.map((store, index) => (
      <div key={index}>
        <div
          className={
            'container-fluid-mobile' +
            (selectedStore && selectedStore.uniqueID === store.uniqueID ? ' open' : '')
          }
        >
          
          <div className="row store-record">
            <div className="store-name">
              <div className="store-name-title">
                {store.Description[0].displayStoreName.toLowerCase().split(',')[0].replace('lenscrafters', 'LensCrafters')},
              </div>
              <div className="store-name-address">{store.addressLine[0].toLowerCase()}</div>
            </div>
            <div className="store-right align-right">
              <div className="store-arrow-up align-right">
                <SlimArrow className="arrow-up" onClick={() => openTilMobile(store)} />
              </div>
              <div className="store-arrow">
                <SlimArrow className="arrow-down" onClick={() => openTilMobile(store)} />
              </div>
              <div className="store-miles hide-mobile">
                {roundNumber(store.distance) + getLabelFallback('CURRENCY_DISTANCE_LABEL')}
              </div>
            </div>
          </div>
          <div className="store-city">
            <span>{store.city.toLowerCase()}, {store.stateOrProvinceName} {store.postalCode}</span>
             <div className="store-miles hide-overPhone">
              {roundNumber(store.distance) + getLabelFallback('CURRENCY_DISTANCE_LABEL')}
             </div>
          </div>
          {selectedStore && selectedStore.uniqueID === store.uniqueID && (
            <div className="store-details">
              <div className="store-details-top row">
                <div className="container-middle align-left">
                  <StorePhoneNumber show={selectedStore}></StorePhoneNumber>
                </div>
                <div className="container-middle align-right">
                  <div className="get-directions-container" onClick={getDirections}>
                    <a href="#" className="get-directions violet-button-negative" data-element-id="OEE_StoreGetDirections">
                      {getLabelFallback('GET_DIRECTIONS_LABEL')}
                    </a>
                  </div>
                </div>
              </div>
              <div className="store-details-bottom row">
                <StoreHours show={selectedStore}></StoreHours>
              </div>
              <div className="row map-container">
                <div className="container-row"> {mapLink && <MapContainer link={mapLink} />}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    ));
  }

  const GetStoreOpeningHours = () => {
    const storeAttributes = selectedStore.Attribute;
    let values;
    storeAttributes.forEach(element => {
      if (element.displayName === 'StoreHours') {
        values = element.displayValue.split(';');
      }
    });
    // filter store hours to show one value for week days
    const storeHours = values.map((item, index) => (
      <div key={index} className={'row row-open-hours'}>
        <div className="store-opening-hours-day M-top M-bottom">
          {' '}
          {getLabelFallback('WEEKDAY' + index)}
        </div>
        <div className="store-opening-hours">{item}</div>
      </div>
    ));
    return storeHours;
  };

  const StoreHours = props => {
    if (props.show) {
      return (
        <div className="container-fluid-boss">
          <div className="row">
            <div className="store-hours-container container-row">
              <span className="store-hours" onClick={() => {
                setShowStoreHours(!showStoreHours);
                window?.tealium_data2track?.push({
                  id: 'Click',
                  data_element_id: 'X_X_FindStoreOverlay_OpeningHours'
                })
              }}>{getLabelFallback('SEE_HOURS_LABEL')}</span>
                {isMobile === false ?
                    showStoreHours ? (
                        <SlimArrow
                        className="arrow-up"
                        data-element-id="X_Pdp_FindStoreOverlay_OpeningHours"
                        onClick={() => setShowStoreHours(!showStoreHours)}
                        />
                    ) : (
                        <SlimArrow
                        className="arrow-down"
                        data-element-id="X_Pdp_FindStoreOverlay_OpeningHours"
                        onClick={() => setShowStoreHours(!showStoreHours)}
                        />
                    )
                    :<></>
                }
            </div>
          </div>
          <div className="row">
            <div className={'container-row opening-hours' + (showStoreHours ? ' open' : '')}>
              {showStoreHours && <GetStoreOpeningHours></GetStoreOpeningHours>}
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const openTilMobile = store => {
    clickedStore(selectedStore && selectedStore.uniqueID === store.uniqueID ? null : store);
    //setShowStoreHours(false);
  };

  const StorePhoneNumber = props => {
    if (props.show && selectedStore) {
      return (
        <div className="container-fluid-boss">
          <div className="row">
            <div className="container-row telephone-number-container">
              <a
                className="telephone-number"
                rel="noreferrer"
                href={'tel:' + selectedStore.telephone1}
                target="_blank"
                data-element-id="OEE_StorePhoneNum"
              >
                {selectedStore.telephone1}
              </a>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const getDirections = () => {
    var directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=';

    if (selectedStore) {
      directionsUrl += encodeURIComponent(
        selectedStore.addressLine[0].trim() +
          ',' +
          selectedStore.city.trim() +
          ',' +
          selectedStore.stateOrProvinceName.trim() +
          ',' +
          selectedStore.postalCode.trim()
      );

      window.open(directionsUrl, '_blank');
    }
  };

  const clickedStore = store => {
    dispatch(actions.setClickedStore(true));
    dispatch(actions.setSelectedStore(store));
  };

  return (
    <div className="container-fluid-boss  container-record">
      <div className="container-fluid-boss store-list-container">
        <div className="stores-list" onScroll={onScrollHandler}>
          {storesList}
        </div>
        {!!shadow && storesList.length > 7 && <div className="stores-list-shadow" style={{ background }}></div>}
        <div className="stores-list-mobile">{storesListMobile}</div>
      </div>
    </div>
  );
};

export default SearchResult;
